import React, { useState } from 'react';
import '../css/Nav.css'; 
import logo from '../assets/logo.png'

const Nav: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleBookDemo = () => {
    window.location.href = '/contact';
  };

  const handleMobileNavClick = (path: string) => {
    window.location.href = path;
    toggleMobileMenu();
  };
  
  const handleMobileDemoClick = () => {
    handleBookDemo();
    toggleMobileMenu();
  };

  return (
    <nav className="nav-bar">
      
      {/* Gradient border wrapper for desktop - applies animation */}
      <div className="nav-container animate-gradient-move">
        {/* White background */}
        <div className="nav-inner">
          <div className="nav-content">
            
            {/* --- Left Group: Logo + Links --- */}
            <div className="nav-left-group">
              {/* Logo */}
              <a className="nav-logo" href="/">
                <img 
                  src={logo}
                  alt="Crikey AI Logo" 
                />
                <span className="nav-logo-text">
                  Crikey<sup>ai</sup>
                </span>
              </a>

              {/* Desktop Navigation Links */}
              <div className="nav-links-desktop">
                <a href="/about">ABOUT</a>
                <a href="/faqs">FAQ'S</a>
              </div>
            </div>

            {/* --- Right Group: CTA + Mobile Button --- */}
            <div className="nav-right-group">
              {/* Desktop CTA Button */}
              <div className="nav-cta-desktop">
                <button onClick={handleBookDemo} className="cta-button">
                  <span>BOOK DEMO</span>
                  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>

              {/* Mobile Menu Button */}
              <div className="mobile-menu-button-wrapper">
                <button
                  onClick={toggleMobileMenu}
                  aria-label="Toggle menu"
                  className="mobile-menu-button"
                >
                  <svg style={{ width: '1.5rem', height: '1.5rem' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {isMobileMenuOpen ? (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    ) : (
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    )}
                  </svg>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Mobile Menu Dropdown - applies animation */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-dropdown animate-gradient-move">
          <div className="mobile-menu-inner">
            <a 
              href="/about" 
              onClick={() => handleMobileNavClick('/about')}
            >
              ABOUT
            </a>
            <a 
              href="/faqs" 
              onClick={() => handleMobileNavClick('/faqs')}
            >
              FAQ'S
            </a>
            <button 
              onClick={handleMobileDemoClick}
              className="cta-button"
            >
              <span>BOOK DEMO</span>
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Nav;